import Vue from 'vue';

export class Tracking {

    static byPK(id) {
        return new Promise((ok, fail) => {
            Vue.http.get('tracking/' + id)
                .then((res) => ok(res.data))
                .catch((err) => fail(err));
        });
    }

    static delete(idTracking) {
        return new Promise((ok, fail) => {
            Vue.http.delete('tracking/' + idTracking)
                .then((res) => ok(res.data))
                .catch((err) => fail(err));
        });
    }
}
